import { render, staticRenderFns } from "./home-xizang.vue?vue&type=template&id=2b095441&scoped=true&"
import script from "./home-xizang.vue?vue&type=script&lang=ts&"
export * from "./home-xizang.vue?vue&type=script&lang=ts&"
import style0 from "./home-xizang.vue?vue&type=style&index=0&id=2b095441&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b095441",
  null
  
)

export default component.exports